import { useTranslation } from 'react-i18next'
import { Chip, Button, GlassCard, SubjectGlyph } from '@/components/aurora'
import { BarChart2, RefreshCw } from 'lucide-react'

export default function PersonalResultCard({ exam, onResult, onRetake }) {
  const { t } = useTranslation()
  const r = exam.user_result
  if (!r) return null

  const attemptsLeft = (exam.allowed_attempts ?? 1) - 1
  const canRetake    = attemptsLeft > 0 && !exam.is_expired

  return (
    <GlassCard variant="urgent" hover className="flex-shrink-0 w-[280px] flex flex-col gap-3 p-4">
      <div className="flex items-start gap-2.5">
        <SubjectGlyph subject={exam.primary_subject} size="sm" />
        <div className="flex-1 min-w-0">
          <h4 className="text-[13.5px] font-semibold m-0 mb-1.5 leading-tight line-clamp-2" style={{ color: 'var(--ink)' }}>
            {exam.title}
          </h4>
          <div className="flex gap-1.5 flex-wrap">
            <Chip variant="score">
              <BarChart2 size={11} strokeWidth={2} />
              {r.total_score} {t('exams.scoreUnit', 'ball')}
            </Chip>
            {r.grade_label && <Chip variant="grade">{r.grade_label}</Chip>}
          </div>
        </div>
      </div>

      <div className="flex gap-1.5 mt-auto">
        <Button variant="green" onClick={onResult} className="flex-1 text-xs px-3 py-2">
          <BarChart2 size={14} strokeWidth={2} /> {t('exams.viewResult', 'Natija')}
        </Button>
        {canRetake && (
          <Button variant="ghost" onClick={onRetake} className="flex-1 text-xs px-3 py-2">
            <RefreshCw size={14} strokeWidth={2} /> {t('exams.retake', 'Qayta')} ({attemptsLeft})
          </Button>
        )}
      </div>
    </GlassCard>
  )
}
